import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Config } from '../models/config.interface';

@Injectable({
  providedIn: 'root',
})
export class EnvConfigService {
  http = inject(HttpClient);

  getEnvironmentConfiguration(): Observable<Config> {
    const url = `${window.location.origin}/api/v1/envconfig`;
    return this.http.get<Config>(url);
  }
}
